const cache: any = {};

/**
 * processColorDiff parses start and end colors returning a new color object that contains the delta between the input colors
 * @param colors Object representing start and end of gradient colors in the RGBA format
 * @param progress Float number presenting the percentage of completion of the color transformation
 * @returns {Object} Reduced color in RGBA format
 */
export const processColorDiff = (
    colors: {
        start: { r: number, g: number, b: number, a: number },
        end: { r: number, g: number, b: number, a: number }
    },
    progress: number
) => {
    return Object.keys(colors.start).reduce((x, y) => {
        let k = y + colors.start[y].toString() + colors.end[y].toString() + progress.toFixed(2);
        if (!cache[k]) {
            let v = (colors.start[y] + ((colors.end[y] - colors.start[y]) * progress));
            cache[k] = y !== "a" ? Math.round(v) : v;
        }
        x[y] = cache[k];
        return x;
    }, { r: 0, g: 0, b: 0, a: 0 });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./helpers/ProcessColorDiff/ProcessColorDiff.ts